<template>
  <v-app :class="getThemeType">
    <v-main>
      <div class="progress-box d-flex align-center pa-4" v-if="loadVal < 100">
        <div class="progress-content">
          <v-progress-linear
            color="light-green darken-4"
            height="10"
            :value="loadVal"
            striped
          ></v-progress-linear>
          <p class="loading-text text-center mt-2">Loading...</p>
        </div>
      </div>
      <router-view v-else />
    </v-main>
    <NavigationBar v-if="loadVal == 100 && showBar" />
  </v-app>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { setCookie } from "./utils/cookie";
export default {
  name: "App",

  components: {
    NavigationBar,
  },

  data() {
    return {
      loadVal: 20,
      initServe: null,
      timer: null,
    };
  },
  computed: {
    ...mapGetters(["getThemeType"]),
    showBar() {
      let url = ["/", "/market", "/assets", "/delivery", "/contract"];
      return url.indexOf(this.$route.path) > -1;
    },
  },
  mounted() {
    document.getElementById("app").style.height = window.innerHeight + "px";
    this.setInnerHeight(window.innerHeight);
    document.documentElement.addEventListener(
      "touchstart",
      function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      },
      false
    );

    var lastTouchEnd = 0;
    document.documentElement.addEventListener(
      "touchend",
      function (event) {
        var now = Date.now();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );

    document.addEventListener("gesturestart", function (event) {
      event.preventDefault();
    });
  },
  created() {
    this.initData();
    // this.getSecondProduct();
  },
  methods: {
    ...mapActions([
      "configFetch",
      "quotesGetNewListFetch",
      "quotesFetch",
      "symbolListFetch",
      "userInfoFetch",
      "languageFetch",
    ]),
    ...mapMutations([
      "setConfigData",
      "setBaseQuotes",
      "setUpdateQuotes",
      "setInnerHeight",
      "setSymbolList",
      "setLanguage",
      "setCurrentRate",
      "setUserInfo",
      "setIsLogin",
      "setThemeType",
      "setLanguages",
    ]),
    async initData() {
      await this.language();
      this.initConfig();
      this.getConfig();
      this.getUserInfoFuc();
      this.getSymbolListFuc();
      
    },
    async language() {
      let res = await this.languageFetch();
      if (res.errCode == 0) {
        this.setLanguages(res.data);
        let lang;
        if(!localStorage.getItem("lang")) {
          lang = res.data[0].key
        }else {
          lang = localStorage.getItem("lang")
        }
        this.setLanguage(lang);
        setCookie("lang", lang);
        this.reloadLangs();
      }
    },
    initConfig() {
      let rate = localStorage.getItem("rate");
      if (rate) {
        rate = JSON.parse(rate);
        this.setCurrentRate(rate);
      } else {
        this.setCurrentRate({
          code: "USD",
          name: "United States dollar",
          price: 1,
          symbol: "$",
        });
      }
      let accountType = localStorage.getItem("account-type") || "real";
      setCookie("account-mode", accountType == "real" ? false : true);
      
      let theme = localStorage.getItem("themeMode");

      if (theme) {
        if (theme == "dark") {
          this.$vuetify.theme.dark = true;
          this.setThemeType("dark");
          document.body.style="background:#111"
        } else {
          this.$vuetify.theme.dark = false;
          this.setThemeType("light");
          document.body.style="background:#fff"
        }
      } else {
        this.$vuetify.theme.dark = true;
        this.setThemeType("dark");
        document.body.style="background:#111"
        localStorage.setItem("themeMode", "dark");
      }
    },
    async getSymbolListFuc() {
      let res = await this.symbolListFetch();
      if (res.errCode == 0) {
        this.setSymbolList(res.data);
      }
    },
    async getConfig() {
      setTimeout(() => {
        this.loadVal = 70;
      }, 200);
      let res = await this.configFetch();
      if (res.errCode == 0) {
        if(res.data.customerBtnIsHidden && res.data.customerServiceType == 'JS') {
          const scriptMatch = res.data.customerService.match(/<script[^>]*>([\s\S]*?)<\/script>/);
          if (scriptMatch && scriptMatch[1]) {
            const scriptElement = document.createElement('script');
            scriptElement.text = scriptMatch[1];
            document.body.appendChild(scriptElement);
          }
        }
        if(res.data.robotGoogleOpen) {
          const scriptSrc = `https://www.google.com/recaptcha/api.js?render=${res.data.robotGoogleSecret}`
          let script = document.createElement("script")
          script.src = scriptSrc;
          document.body.appendChild(script);
        }

        this.setConfigData(res.data);
        document.title = res.data.systemName
        let favicon = document.querySelector('link[rel="icon"]')
        favicon = document.createElement('link')
        favicon.rel = 'icon'
        favicon.href = res.data.pc2Logo
        document.head.appendChild(favicon)
        setTimeout(() => {
          this.loadVal = 98;
        }, 200);
        setTimeout(() => {
          this.loadVal = 100;
        }, 400);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#app {
  overflow-y: auto;
  background: var(--v-section2_bg-base);
  ::v-deep .v-application--wrap {
    height: 100%;
  }
  ::v-deep .v-main {
    height: 100%;
  }
  ::v-deep .v-main__wrap {
    height: 100%;
  }
  .progress-box {
    height: 100vh;
    .progress-content {
      width: 100%;
      .loading-text {
        font-size: 18px;
      }
    }
  }
}
</style>
